{
  "newProject": "New Project",
  "interestPayment": "Interest payment on ",
  "dividendPayment": "Dividend payment",
  "simulated": "Simulated",
  "purchase": "Purchase",
  "sale": "Sale",
  "baseCurrency": "Project base currency",
  "progressIndicator": "Preferred progress indicator",
  "roi": "ROI",
  "roiSliderDate": "ROI now",
  "roiNextGoal": "ROI at goal",
  "duration": "Duration",
  "goal": "Goal",
  "noInvestment": "No data",
  "visible": "Visible outside of this project?",
  "planned": "Planned",
  "actual": "Actual gain",
  "yes": "yes",
  "noDraftMode": "no",
  "delete": "Delete project",
  "addGoal": "Add goal",
  "addGoalDescription": "Define a goal for this project.",
  "deleteGoal": "Delete goal",
  "name": "Goal title",
  "transactions": "Transactions",
  "assets": {
    "label": "Project assets",
    "tooltip": "Bank accounts and assets used in the project are displayed here."
  },
  "add": "Add transaction",
  "addQuote": "Add future value",
  "addQuoteDescription": "Define the future value of any asset in this project.",
  "addQuoteButtonDisabled": "You need to add at least one asset to this project before you can add a future value.",
  "addQuoteButtonEnabled": "Add future value of a project asset",
  "selectDepositAccount": {
    "header": "Select deposit account",
    "prompt": "Which deposit account should we use for the proceeds and costs of this asset?"
  },
  "inflow": {
    "labelTop": "Inflow",
    "labelBottom": "Receive money"
  },
  "outflow": {
    "labelTop": "Outflow",
    "labelBottom": "Spend money"
  },
  "transfer": {
    "labelTop": "Transfer",
    "labelBottom": "between accounts"
  },
  "buy": {
    "labelTop": "Buy",
    "labelBottom": "assets | deposits"
  },
  "sell": {
    "labelTop": "Sell",
    "labelBottom": "assets | deposits"
  },
  "newAccount": {
    "label": "New",
    "description": "New account"
  },
  "applyTemplate": "Apply project template",
  "removeTemplate": "Remove project template",
  "addTransaction": "Add transaction",
  "growthRates": "Asset growth rates",
  "growthRatesDescription": "You can define individual growth rates for each asset. They will apply to this asset in this project only.",
  "growthRatesNonIsolated": "These growth rates also apply to assets outside of this project. Switch project to isolated mode to define project-specific growth rates.",
  "transactionTypes": "Transaction types",
  "transactionDetails": "Transaction details",
  "date": "Date",
  "transactionDate": {
    "label": "Transaction date",
    "tooltip": "Always rounded down to the 1st day of current month. Adjust order of transactions within one month by dragging transactions in the correct sequence in the Project Details view.",
    "error": "Date must be a future date. Use Account Details view to add a past transaction."
  },
  "recurringTransaction": {
    "label": "Should this transaction repeat regularly?"
  },
  "indexed": {
    "label": "Should the amount be increased every year?",
    "byInflation": "increase by inflation rate (link)",
    "increaseBy": "increase by"
  },
  "repeating": {
    "label": "Repeating pattern",
    "every": "Repeat every",
    "month": "months",
    "year": "years",
    "endBy": "Repetition should end",
    "never": "never",
    "after": "after",
    "afterError": "Maximum number of periods is 999.",
    "occurrences": "occurrences",
    "on": "on"
  },
  "synchronising": "Synchronising...",
  "save": "Save",
  "cancel": "Cancel",
  "deleteQuote": "Delete this future value",
  "amount": {
    "label": "Amount",
    "inflowsCanOnlyBePositive": "Inflows can only be positive. Use Outflows for negative transactions.",
    "outflowsCanOnlyBeNegative": "Outflows can only be negative. Use Inflows for positive transactions.",
    "transfersCanOnlyBePositive": "Transfers should always be positive. To define a money flow in the opposite direction, swap the To and From accounts around."
  },
  "baseCurrencyAmount": {
    "label": "Amount in"
  },
  "exchangeRate": {
    "label": "FX rate to ",
    "mustBeGreaterThanZero": "Exchange rate must be greater than zero."
  },
  "switchToAmount": "Switch to amount",
  "switchToFxRate": "Switch to FX rate",
  "currency": "Currency",
  "account": {
    "label": "Transaction will be deducted from this account"
  },
  "accountTo": {
    "label": "Transaction will appear on this account",
    "error": "You cannot transfer money to the same account."
  },
  "transactionDescription": {
    "label": "Transaction description will be",
    "placeholder": "Salary",
    "required": "Please enter a description",
    "length": "Description must be at least 2 characters long"
  },
  "assetAccount": {
    "label": "New asset will appear on this account",
    "error": "Connected deposit account for this account is not defined."
  },
  "assetContributionLabel": {
    "label": "New contribution will appear on this account",
    "error": "Connected deposit account for this account is not defined."
  },
  "designatedDepositConnectedAccountIndex": {
    "label": "Bank account for this transaction",
    "error": "Error."
  },
  "assetName": {
    "tooltip": "This is just a placeholder information which is used for simulations.",
    "label": "Asset name",
    "orISIN": "or ISIN / WKN code",
    "placeholder": "Tesla stocks"
  },
  "assetSymbol": {
    "tooltip": "Pick an existing asset from the list or create a new one. You can use a placeholder name, as this it is only used for simulations.",
    "label": "Stock name / ISIN / WKN",
    "placeholder": "DE0000A1B2C3"
  },
  "assetMetal": {
    "label": "Metal",
    "error": "Please select a metal."
  },
  "assetWeight": {
    "label": "Weight (g)",
    "error": "Please enter weight."
  },
  "assetPurity": {
    "label": "Purity (‰)",
    "error": "Please enter purity in parts per 1000 (e.g. 999 or 965)."
  },
  "assetAdditionalValue": {
    "label": "Extra value (%)",
    "tooltip": "Enter a percentage by which to increase this asset's value due to its historical or artistic value."
  },
  "assetAmount": {
    "label": "How many pieces of asset to",
    "buy": "buy",
    "sell": "sell"
  },
  "depositAmount": {
    "label": "Amount"
  },
  "deposit": "deposit",
  "assetUnitPrice": {
    "label": "Price per unit",
    "error": "Asset unit price must be greater than 0."
  },
  "assetContribution": {
    "label": "Amount",
    "error": "Contribution must be greater than 0."
  },
  "assetUnitPriceBaseCurrency": {
    "label": "Price in ",
    "error": "Asset unit price must be greater than 0."
  },
  "quote": {
    "label": "Price"
  },
  "quoteBaseCurrency": {
    "label": "Price in ",
    "error": "Asset unit price must be greater than 0."
  },
  "todaysPrice": "Current price of {{displayName}} is",
  "selectAnOption": "Select an option",
  "createNewAccount": "Create new account",
  "errorNotAllFields": "Please fill out all the fields.",
  "templateInitialisationError": "Error while initialising project template.",
  "quoteAlreadyExists": "Future value for this asset and date already exists. It will be overwritten if you click Save.",
  "quoteProjectWillBeChanged": "When you click Save, this future value will become part of this project. It will be deleted if you delete the project.",
  "isolatedWarning": "Transactions and future values are not visible outside of this project",
  "collisions": "Which future values are we keeping?",
  "collisionsDescription": "You are switching an isolated project to a global project. This project has some future values that are already defined in other projects. You can either keep the values from this project, or keep the values from the other projects.",
  "asset": "Asset",
  "thisProjectQuote": "This project",
  "globalQuote": "Other projects",
  "allCollisionsMustBeResolved": "Please select one of the values in each row.",
  "recurring": "Recurring transactions",
  "simulatedDividends": "Simulated dividends",
  "simulatedInterest": "Simulated interest",
  "simulatedQuotes": "Future values",
  "applyTemplateDescription": "Apply a set of transactions and future values to your project. You can then edit them as you wish. If you don't like the effect, you can remove the entire template with one click.",
  "templates": {
    "select": "Select",
    "investToRent": {
      "name": "Buy property to rent out with a mortgage",
      "description": "You want to buy a property to rent out. You will take out a mortgage to finance the purchase. You will rent out the property and use the rental income to pay off the mortgage. You will also pay property taxes and other expenses. You want to see how the property will perform over time.",
      "role1": "Money for downpayment",
      "transaction1": "First incoming transfer.",
      "transaction2": "Second incoming transfer."
    }
  }
}
